import { jsx as _jsx } from "react/jsx-runtime";
import { RichTextDisplay } from '../RichTextDisplay/RichTextDisplay.js';
export function RichTextFieldDisplay({ fieldSpec, value }) {
    return _jsx(RichTextDisplay, { fieldSpec: fieldSpec, value: value });
}
//# sourceMappingURL=RichTextFieldDisplay.js.map